export default __webpack_public_path__ + "static/media/menu-reports.a47d8cbd.svg";